import autosize from 'autosize';

class FormField {
	/**
	 * Placeholder toggling
	 *
	 * @param {object} node
	 */
	static toggleFilledModifier(node) {
		if (node.value) node.classList.add('--filled');
		else node.classList.remove('--filled');
	}

	/**
	 * Toggle placeholders of all input on the page
	 */
	static toggleFilledAllInputs() {
		for (const input of document.getElementsByClassName('form-field__input')) {
			this.toggleFilledModifier(input);

			// Textarea
			if (input.tagName === 'TEXTAREA' && input.classList.contains('--autosize')) {
				autosize.destroy(input);
				autosize(input);
			}
		}
	}

	static createPlaceholdersForInputs(node = null) {
		const wrapper = node || document;
		for (const inputWrap of wrapper.getElementsByClassName('form-field')) {
			const input = inputWrap.getElementsByClassName('form-field__input')[0];
			const fieldWrap = inputWrap.getElementsByClassName('form-field__wrap')[0];

			if (!fieldWrap.getElementsByClassName('form-field__placeholder').length) {
				// Creating placeholder
				const inputPlaceholder = document.createElement('div');
				inputPlaceholder.className = 'form-field__placeholder';
				if (input.tagName === 'DIV') inputPlaceholder.innerHTML = input.getAttribute('data-placeholder');
				else inputPlaceholder.innerHTML = input.placeholder;
				fieldWrap.appendChild(inputPlaceholder);

				// Focus on input when placeholder is clicked
				inputPlaceholder.addEventListener('click', () => input.focus());
			}
		}
	}

	static attachEventsToInputs(node = null) {
		const wrapper = node || document;
		for (const inputWrap of wrapper.getElementsByClassName('form-field')) {
			const input = inputWrap.getElementsByClassName('form-field__input')[0];

			FormField.toggleFilledModifier(input);

			// Placeholder location onchange input value
			input.addEventListener('change', () => FormField.toggleFilledModifier(input));

			// Placeholder location onfocus input
			input.addEventListener('focus', () => FormField.toggleFilledModifier(input));
		}
	}

	/**
	 * Helper for setting value for any field.
	 *
	 * @param node
	 * @param value
	 * @param trigger
	 */
	static setValue(node, value, trigger = true)
	{
		node.val(value);

		if(node.is('select')) {
			node.find(`option[value="${value}"]`).attr('selected', 'selected');
		} else if (node.is(`[type="checkbox"]`)) {
			node.attr('checked', 'checked');
		}

		if(trigger) {
			// node.trigger('change');
		}
	}
}

export default FormField;
